<template>
    <zen-one :showuserinfo="false" title="Sistem Hasil Bersepadu Kedah (iHasil)" :crumbs="crumbs">

        <z-page title="Senarai : Kewangan 38 ">
            <w-form >
              <w-flex class="mt3">
                     <div class="xs4 mr3">
                        <z-lookup
                        label="Kaedah Bayaran"
                        placeholder="Sila Pilih Kaedah Bayaran"
                        :url='service_utiliti+"lookup/cara_bayar"'
                        :sort="false" :cache="false"
                        v-model="cari.lkp_cara_bayaran_id"/>
                    </div>
                    <div class="xs4 mr3">
                       <w-input
                        type="date"
                        label="Tarikh Transaksi"
                        name="tarikh_tansaksi"
                        v-model="cari.tarikh_transaksi">
                       </w-input>
                    </div>
                    <div class="xs4">
                       <w-input
                        type="date"
                        label="Hingga"
                        name="hingga_tarikh"
                        v-model="cari.hingga_tarikh">
                       </w-input>
                    </div>
              </w-flex>
            </w-form>

            <w-flex class="mt3 mb3" wrap align-center justify-end>
              <div class="text-right">
                  <w-button class="ml1" v-on:click="reset()" bg-color="warning">
                      <w-icon>fal fa-redo-alt</w-icon>&nbsp;Reset
                  </w-button>
                  <w-button class="ml1 " @click="search()">
                    <w-icon>fal fa-search</w-icon>&nbsp;Cari
                  </w-button>
              </div>
            </w-flex>

            <z-table ref="tbluser" title="" :headers="table.headers" :items="table.items" :meta="table.meta" class="">
                    <template #item-cell.action="{ item, label, header, index }">
                        <w-flex class="flex justify-center">
                        <inertia-link :href='$route("kutipan.kew38.show",item.id)'>
                        <w-tooltip top>
                            <template #activator="{ on }">
                                <w-icon v-on="on" >
                                fal fa-pencil
                                </w-icon>
                            </template>
                            Papar
                            </w-tooltip>
                        </inertia-link>
                        </w-flex>
                    </template>
            </z-table>

        </z-page>
    </zen-one>
</template>

<script>
import { reactive } from 'vue'
// import ZenOne from '@/Shared/ZenOne'
import ZResource from '@/Modules/z-resource-service'


export default {
  extends: ZResource,
  components: {
    // ZenOne
  },
  props: {
    items: [Array, Object],
  },
  data() {
    return {
        resourceurl: this.service_kutipan +'penyata_pemungut',
        reload: true,
        crumbs: [
        { label: 'iHasil', route: '/' },
        { label: 'Kutipan', route: '/kutipan' },
        { label: 'Kewangan 38', route: '/kutipan/kew38' },
        { label: 'Senarai', route: '/kutipan/kew38' },
          ],
          form: {
            no: '',
            no_dokumen: '',
            },
           cari : {lkp_cara_bayaran_id:'', tarikh_transaksi: '' , hingga_tarikh:''},

        }
  },
  methods: {
    search() {
      var url = window.route('kutipan.kew38.index')+'?lkp_cara_bayaran_id='+this.cari.lkp_cara_bayaran_id+'&tarikh_transaksi='+this.cari.tarikh_transaksi+'&hingga_tarikh='+this.cari.hingga_tarikh;
      this.$inertia.visit(url, { preserveScroll : true})
    },
    reset(){
      this.cari = {lkp_cara_bayaran_id: '', tarikh_transaksi: '', hingga_tarikh: ''}
      this.search()
    },
  },

  watch: {

  },
  mounted() {
    this.dialog.width = 500
    this.cari = location.search.slice(1).split('&').map(p => p.split('=')).reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});
    if(this.cari.lkp_cara_bayaran_id == 'undefined'){this.cari.lkp_cara_bayaran_id = ''}
    if(this.cari.tarikh_transaksi == 'undefined'){this.cari.tarikh_transaksi = ''}
    if(this.cari.hingga_tarikh == 'undefined'){this.cari.hingga_tarikh = ''}
  },
}
</script>
<style>
.w-select__menu {
    z-index: 999999;
}
</style>
